import axios, { type AxiosInstance } from 'axios'

const dcmApiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.DCM_API_URL,
  headers: {}
})

export default dcmApiClient
